module.exports = __webpack_public_path__ + "static/media/slide-1r.8fe54747.jpg";